module.exports = "/dist/media/icons.912ec66d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/themes/default/assets/fonts/icons.svg
// module id = 890
// module chunks = 0